/** OP patient journey — reception → doctor → pharmacy/lab */
export const Q = {
  BOOKED: 'Booked',
  CHECKED_IN: 'Checked In',
  AWAITING_PAYMENT: 'Awaiting Payment',
  WAITING_DOCTOR: 'Waiting for Doctor',
  IN_CONSULTATION: 'In Consultation',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  NO_SHOW: 'No Show',
  MISSED: 'Missed',
  RESCHEDULED: 'Rescheduled',
  DELETED: 'Deleted',
};

/** Q Page workflow tabs */
export const Q_TAB = {
  NEW: 'new',
  BOOKED: 'booked',
  FOLLOWUPS: 'followups',
  OTHER: 'other',
  MY_OPD: 'myopd',
  COMPLETED: 'completed',
};

export const DEFAULT_QUEUE_TAGS = [
  'VIP', 'Senior Citizen', 'PWD', 'Corporate', 'Camp', 'Referral', 'Insurance',
];

export function queueRowId(row) {
  return row.queueId || row.id;
}

export function todayStr(d = new Date()) {
  return d.toISOString().slice(0, 10);
}

const OTHER_STATUSES = new Set([Q.CANCELLED, Q.NO_SHOW, Q.MISSED, Q.RESCHEDULED, Q.DELETED]);
const ACTIVE_STATUSES = new Set([
  Q.CHECKED_IN, Q.AWAITING_PAYMENT, Q.WAITING_DOCTOR, Q.IN_CONSULTATION,
]);

export function isFollowUpVisit(row) {
  const vt = (row.visitType || '').toLowerCase();
  return vt.includes('follow');
}

export function visitDateOf(row) {
  return row.visitDate || (row.createdAt ? row.createdAt.slice(0, 10) : todayStr());
}

/** Bucket a queue row into a Q Page section */
export function queueTab(row, today = todayStr()) {
  const s = row.status;
  const vd = visitDateOf(row);

  if (OTHER_STATUSES.has(s)) return Q_TAB.OTHER;
  if (s === Q.COMPLETED) return Q_TAB.COMPLETED;
  if (ACTIVE_STATUSES.has(s) && vd === today) return Q_TAB.MY_OPD;
  if (s === Q.BOOKED && isFollowUpVisit(row)) return Q_TAB.FOLLOWUPS;
  if (s === Q.BOOKED) return Q_TAB.BOOKED;
  if (ACTIVE_STATUSES.has(s)) return Q_TAB.MY_OPD;
  return Q_TAB.BOOKED;
}

export function filterQueueByTab(rows, tab, today = todayStr(), customSections = []) {
  const custom = (customSections || []).find((s) => s.id === tab);
  if (custom) {
    if (custom.tag) {
      return rows.filter((r) => (r.tags || []).includes(custom.tag));
    }
    if (custom.status) {
      return rows.filter((r) => r.status === custom.status);
    }
    if (custom.visitType) {
      return rows.filter((r) => (r.visitType || '').toLowerCase().includes(custom.visitType.toLowerCase()));
    }
  }
  return rows.filter((r) => queueTab(r, today) === tab);
}
